import { AfterViewInit, ChangeDetectorRef, Component, DoCheck, ElementRef,EventEmitter, HostListener, Input, OnInit, Output, QueryList, Renderer2, ViewChild } from '@angular/core'
import { TextScreen } from './text-screen.model'
import { AlertController, AlertInput, IonContent, LoadingController } from '@ionic/angular';
import { CordovaService } from '../cordova.service'
import { AppState } from '../app.service'
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { AlertAddNotesComponent } from '../alert-add-notes/alert-add-notes.component';
import { LibraryService } from '../my-library/library.service';
import { ToasterService } from '../toaster.service';
import { SpinnerService } from '../spinner.service';
import { AlertDeletePostComponent } from '../alert-delete-post/alert-delete-post.component';
import { SessionService } from '../session/session.service';
import { HomeUiService } from '../new-design/home-ui.service';
import { StreamingAudioOptions, StreamingMedia, StreamingVideoOptions } from '@ionic-native/streaming-media/ngx';
import { YoutubeVideoPlayer } from '@awesome-cordova-plugins/youtube-video-player/ngx';
import { IonFab, ModalController, Platform } from '@ionic/angular';
import mixpanel from 'mixpanel-browser';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CurrentPathRegistration, UtilityService } from '../common-services/utility.service';
import { PathRegistration } from '../user/path-registration.model';
import { UserService } from '../user/user.service';
import { User } from '../user/user.model';
import { YourPathComponent } from '../new-design/your-path/your-path.component';
import { YourPathNewComponent } from '../new-design/your-path-new/your-path-new.component';
import { ActivatedRoute, Router } from '@angular/router'
import { I18n } from '../i18n.service';
import { MotionDuration, MotionEasing } from '../constants/motion-tokens';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { KyperDataApiService } from '../services/kyper-data-api.service';
import { PlyrComponent } from '@makiwin/ngx-plyr';
import * as Plyr from 'plyr';
import { MediaTypesScreenComponent } from '../media-types-screen/media-types-screen.component';
import { AnimationsService } from '../shared/animations.service';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { HttpClient } from '@angular/common/http';
export interface JournalPostItem {
  [journalPostItem: string]: any;
}
type AudioFiles = {
  // title: string;
  // url: string;
  // cover: string;
  src: string;
  type: string;
};

const allowedType = ['pdf','url','jpg', 'jpeg', 'png', 'gif', 'webp', 'mp4', 'mp3', 'wav', 'doc', 'docx', 'txt', 'csv', 'xlsx', 'xls','image','attachment','link','document','ppt','pptx']

@Component({
  selector: 'first90-text-screen',
  templateUrl: './text-screen.component.html',
  styleUrls: ['./text-screen.component.scss'],

  animations: [
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]

})
export class TextScreenComponent implements OnInit, DoCheck, AfterViewInit {
  /**
   * Video src with a `#t=` media fragment so a still frame shows before playback.
   *
   * iOS Safari / WKWebView paint nothing until the element has decoded a frame — `preload="metadata"`
   * fetches duration and dimensions only, so the video area renders black where Chrome happens to
   * show frame 0. Asking for a time offset makes iOS seek to (and paint) that frame without playing.
   *
   * The fragment is appended AFTER any query string, which is safe for presigned URLs: fragments are
   * never sent to the server, so the signature is untouched. It does need the host to serve HTTP
   * Range requests (S3/CloudFront do) — without that, iOS still shows nothing.
   */
  get videoUrl(): string {
    const url = this.screenContent?.media?.url;
    if (!url || url.includes('#')) { return url; }
    return `${url}#t=0.001`;
  }

  @Input() progressItems = []
  @Input() currentIndex = 0
  @Input() currentDay = 0
  @Input() screenContent: any
  @Input() screenId: any
  @Input() chapterIndex;
  @Input() stepIndex
  @ViewChild("stepTitle") stepTitle: ElementRef;
  @Input() screen
  @Input() back = true
  isMobileWebIos = false;
  isMobileWeb = false;
  // @Input() close = true
  allowScreenCount: boolean
  @Input() inverted = false
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
   @ViewChild('audioPlayer', { static: false }) audioPlayer!: ElementRef<HTMLAudioElement>;
  @Output('onClick') onClick = new EventEmitter<null>()
  @Output('onBack') onBack = new EventEmitter<null>()
  @Output('onClose') onClose = new EventEmitter<null>()
  isMobile: boolean;
  innerTextHtml: any
  isPaused=false;
  videoEmbedUrl: SafeResourceUrl | null = null;
  // The iOS app runs from file://, so YouTube rejects the iframe (no Referer, error 153); show a tappable thumbnail instead.
  youtubePreview: { thumbnailUrl: string; watchUrl: string } | null = null;
  @Input() habit: any
  @Input() poll: any
  @Input() question: any
  @Input() document: any
  @Input() survey: any
  @Input() onboardingSettingScreen: any;
  currentPath: any
  currentUser: User
  savedLibraryPosts: any
  postToJournal: JournalPostItem
  recentSavedPost: any
  savedScreenId: any
  @Input() isAlreadyPresent: boolean
  @Input() showFilledBookmark: boolean
  @Input() isDocumentOnly: boolean
  @Input() reflection: any
  flag= false;
  backTo: string
  screensIds = []
  currentScreenIndex = 0
  showBackdrop;
  // @ViewChildren('focusableElement') focusableElements: QueryList<ElementRef>;
  @ViewChild(IonContent) content: HTMLIonContentElement;
  @ViewChild('fabComponent') fabComponent: IonFab; 
  // isMobileWeb=false;
  iOSYoutubeUrl;
  streaksInfo;
  currentTime = 0;
   player = new Audio;
  duration: any = -1;
  isPlaying
   audioList:AudioFiles[]=[]
   playerInit: Plyr;
  plyr: PlyrComponent;
  isContentViewed;
  @Input() addTextAnimation: boolean;
  screenImageUrl;
  screenAssetsImageUrl;
  wasPlayingBeforeSeek=false
  private animationTimeout: any;
  hasScrollbar = false;
  showScrollToBottom = false;
  private readonly BOTTOM_THRESHOLD = 1;
  headingFontSize = 20.84;
  bodyFontSize = 14.44;
  private fontSizeSubscription: any;
  private fontSizeSaveSubject = new Subject<{ headingFontSize: number; bodyFontSize: number }>();
  private fontSizeSaveSubscription?: Subscription;
  public pathRegistration: CurrentPathRegistration;
  private resizeObserver!: ResizeObserver;
  constructor(private cordovaService: CordovaService,
    private appState: AppState,
    private _sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private libraryService: LibraryService,
    private spinnerService: SpinnerService,
    private toasterService: ToasterService,
    private i18n: I18n,
    private render:Renderer2,
    private sessionService: SessionService,
    private cdRef: ChangeDetectorRef,
    private youtubePlayer: YoutubeVideoPlayer,
    public homeUIService: HomeUiService,
    public utilService: UtilityService,
    private userService: UserService,
    private router: Router,
    public platform: Platform,
    private modalController: ModalController,
    private alertController: AlertController,
    private kyperuserDataApiService: KyperDataApiService,
    private animationService: AnimationsService,
    private streamingMedia: StreamingMedia,
    private loadingCtrl: LoadingController,
    private http: HttpClient, private socialSharing: SocialSharing,
    private file: File,private transfer: FileTransfer,
    private elRef: ElementRef) {
    this.isMobile = this.appState.get('isMobile')
    this.currentPath = this.appState.get('currentPath')
    this.currentUser = this.appState.get('currentUser')
    this.pathRegistration = this.appState.get('pathRegistration')
    if (this.pathRegistration?.pathData?.headingFontSize && this.pathRegistration?.pathData?.bodyFontSize) {
      this.homeUIService.updateFontSize(this.pathRegistration.pathData.headingFontSize, this.pathRegistration.pathData.bodyFontSize);
    }
  }

  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.innerTextHtml = this._sanitizer.bypassSecurityTrustHtml(this.linkifyHtml(this.screenContent?.body ?? this.screenContent?.html));
    this.iOSYoutubeUrl = this.extractUrlFromIframe(this.screenContent?.body);
    this.streaksInfo = this.appState.get('dailyStreaksInfo');
    if(this.screen?.screen?.contentType == 'miniApp') {
      // if (this.isMobile ) {
        // this.innerTextHtml = this._sanitizer.bypassSecurityTrustHtml(this.screenContent?.content || '');
        this.innerTextHtml = this.convertHtmlToDataUrl(this.screenContent?.html || '');
      // }
      // else {
      //   this.innerTextHtml = this._sanitizer.bypassSecurityTrustResourceUrl(
      //     'data:text/html;charset=utf-8,' + encodeURIComponent(this.screenContent?.content)
      //   );
      // }
    }
    this.screenImageUrl = this.screenContent?.media?.type == 'image' &&this.screenContent?.media?.url?.trim()?.length > 0 ? this.screenContent?.media?.url : null;
    this.screenAssetsImageUrl = this.screen?.assets?.length>0?this.screen?.assets?.filter(media => media.assetType == 'image' &&media.url&& media.url?.trim()?.length > 0)?.[0]?.url : null
    // Sanitized once here: re-sanitizing in a getter returns a new object every change detection and reloads the iframe.
    const embedUrl = this.isVideo ? this.getVideoEmbedUrl(this.screenContent?.media?.url) : null;
    const youtubeId = this.isVideo && this.platform.is('ios') && !this.platform.is('mobileweb') ? this.getYoutubeId(this.screenContent?.media?.url) : null;
    this.youtubePreview = youtubeId ? {
      thumbnailUrl: `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`,
      watchUrl: `https://www.youtube.com/watch?v=${youtubeId}`
    } : null;
    this.videoEmbedUrl = embedUrl && !this.youtubePreview ? this._sanitizer.bypassSecurityTrustResourceUrl(embedUrl) : null;
    this.checkLibraryStatus(this.poll,this.survey,this.document,this.question,this.habit);
    //  setTimeout(() => {
    //   this.addTextAnimation = true;
    // }, 3000);
  }

  // removeAnimation() {
  //   this.addTextAnimation = false;

  //   setTimeout(() => {
  //     this.addTextAnimation = true;
  //   }, 3000);
  // }

  convertHtmlToDataUrl(html: string) {
  const base64 = btoa(
    encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16))
    )
  );

  const dataUrl = `data:text/html;base64,${base64}`;

  return this._sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
}

  // Wraps plain-text URLs (http/https/www.) in <a> tags, skipping text already inside <a>/<script>/<style>.
  linkifyHtml(html: string): string {
    if (!html) {
      return html;
    }
    const urlPattern = /((?:https?:\/\/|www\.)[^\s<]+[^\s<.,;:!?)\]'"])/gi;
    let skipDepth = 0;

    return html.split(/(<[^>]*>)/g).map(part => {
      if (/^<a\b/i.test(part) || /^<(script|style)\b/i.test(part)) {
        skipDepth++;
        return part;
      }
      if (/^<\/(a|script|style)>/i.test(part)) {
        skipDepth = Math.max(0, skipDepth - 1);
        return part;
      }
      if (/^<[^>]*>$/.test(part) || skipDepth > 0) {
        return part;
      }
      return part.replace(urlPattern, match => {
        const href = match.toLowerCase().startsWith('www.') ? `https://${match}` : match;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      });
    }).join('');
  }

  removeAnimation(event) {
    // if ((event.target as HTMLElement).closest('.content-overflow > div')) {
    //   return;
    // }

    this.addTextAnimation = false;

    // setTimeout(() => {
    //   this.addTextAnimation = true;
    // }, 3000);

    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }

    this.animationTimeout = setTimeout(() => {
      this.addTextAnimation = true;
    }, 3000);
  }

  onFooterClick(event: Event): void {
    // User interacted with footer — keep it visible and reset the 3s timer
    event?.stopPropagation();
    this.addTextAnimation = false;

    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }

    this.animationTimeout = setTimeout(() => {
      this.addTextAnimation = true;
    }, 3000);
  }

  extractUrlFromIframe(iframeHtml): string | null {
    if (!iframeHtml) return null;

    const iframeSrcMatches = iframeHtml.matchAll(/<iframe[^>]+src=["']([^"']+)["']/gi);

    for (const match of iframeSrcMatches) {
      const url = match[1];
      // Only process if it's a YouTube URL
      if (url.includes('youtube.com') || url.includes('youtu.be')) {
        const idMatch = url.match(
          /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|v\/))([a-zA-Z0-9_-]{11})/
        );
        if (idMatch) {
          const videoId = idMatch[1];
          return `https://www.youtube.com/watch?v=${videoId}`;
        }
      }
    }

    return null; 
  }



  ngDoCheck() {
    this.savedLibraryPosts = this.appState.get('savedPosts')
    this.recentSavedPost = this.appState.get('recentSavedStep')
    this.savedScreenId = this.appState.get('savedScreenId')
  }

  patchIframesForFullscreen() {
  const container = this.stepTitle?.nativeElement;
  if (!container) return;
  const iframes: NodeListOf<HTMLIFrameElement> = container.querySelectorAll('iframe');
 // console.log("iframes", iframes)
  iframes.forEach((iframe) => {
    const src = iframe.src;
    // Apply only for YouTube embeds
    if (src.includes('youtube.com/embed')) {
      const url = new URL(src);
      url.searchParams.set('fs', '0');
      // url.searchParams.set('playsinline', '1');
      // url.searchParams.set('cc_load_policy', '1');
      iframe.src = url.toString();
      // Wrap iframe in a div
      const wrapper = document.createElement('div');
      wrapper.classList.add('youtube-video-wrapper');
      const fullscreenBtn = document.createElement('button');
      fullscreenBtn.classList.add('fullscreen-toggle');
      fullscreenBtn.innerText = '⛶';
      fullscreenBtn.addEventListener('click', () => {
        this.enterNativeFullscreen(wrapper);
        fullscreenBtn?.remove();
        wrapper.classList.add('full-screen-video-wrapper');
      });
      iframe.parentNode?.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
      wrapper.appendChild(fullscreenBtn);
    }
  });
}
async enterNativeFullscreen(wrapper: HTMLElement) {
  // Show close button
  const closeBtn = document.createElement('button');
  closeBtn.classList.add('exit-fullscreen');
  closeBtn.innerHTML = '✕';
  const fullscreenBtn = document.createElement('button');
  fullscreenBtn.classList.add('fullscreen-toggle');
  fullscreenBtn.innerText = '⛶';
  fullscreenBtn.addEventListener('click', () => {
    this.enterNativeFullscreen(wrapper);
    fullscreenBtn?.remove();
    wrapper.classList.add('full-screen-video-wrapper');
  });
  closeBtn.addEventListener('click', () => {
    this.exitNativeFullscreen();
    wrapper.classList.remove('full-screen-video-wrapper');
    wrapper.appendChild(fullscreenBtn);
  });
  wrapper.appendChild(closeBtn);
  // Request fullscreen on wrapper
  const elem: any = wrapper;
  if (elem.requestFullscreen) {
    await elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) {
    await elem.webkitRequestFullscreen(); // for Safari
  } else if (elem.msRequestFullscreen) {
    await elem.msRequestFullscreen(); // for IE
  }
}
  exitNativeFullscreen() {
  const doc: any = document;
  if (doc.exitFullscreen) {
    doc.exitFullscreen();
  } else if (doc.webkitExitFullscreen) {
    doc.webkitExitFullscreen();
  } else if (doc.msExitFullscreen) {
    doc.msExitFullscreen();
  }
  // Optional: remove custom button if needed
  const closeBtn = document.querySelector('.exit-fullscreen');
  closeBtn?.remove();
}


  ngAfterViewInit() {
    var hElement: HTMLElement = this.elRef.nativeElement;
    var allDivs = hElement.getElementsByClassName('ql-video');
    if (allDivs?.length >= 1) {
      // let data = allDivs[0]['contentWindow']
      this.appState.set('disableVideo', true)
      this.appState.set('iframeObject', allDivs[0])
    }
    if (this.isMobile && this.platform.is('ios')) {
      setTimeout(() => this.patchIframesForFullscreen(), 100);
    }
    if(this.screenContent?.media?.type=='audio') 
    {
         this.player.src = this.screenContent?.media.url;
    this.duration = this.player.duration;
    const audioType = this.detectAudioType(this.screenContent?.media.url)
    const a1 = { src: this.screenContent?.media.url, type: audioType }
    this.audioList.push(a1);
    }
    const el = this.audioPlayer?.nativeElement;
    if (el) {
      el.addEventListener('loadedmetadata', () => {
        this.duration = el?.duration;
      });

      el.addEventListener('timeupdate', () => {
        this.currentTime = el?.currentTime;
      });
    }
    this.fontSizeSubscription = this.homeUIService.fontSize$.subscribe(({ heading, body }) => {
      this.headingFontSize = heading;
      this.bodyFontSize = body;
      setTimeout(() => this.changeSubTextFont(), 0);
    });
    this.fontSizeSaveSubscription = this.fontSizeSaveSubject
      .pipe(debounceTime(500))
      .subscribe(({ headingFontSize, bodyFontSize }) => {
        this.savePathRegistrationFontSize(headingFontSize, bodyFontSize);
      });
  }

  detectAudioType(audioUrl: string): string {
    const extension = audioUrl.split('.').pop()?.toLowerCase(); // Extract file extension
    switch (extension) {
      case 'mp3':
        return 'audio/mp3';
      case 'wav':
        return 'audio/wav';
      case 'ogg':
        return 'audio/ogg';
      case 'm4a':
        return 'audio/mp4'; // For .m4a or .mp4 audio files
      case 'aac':
        return 'audio/aac';
      default:
        return 'audio/mpeg'; // Default type
    }
  }

  get hasValidAsset() {
   return  this.screen?.assets?.length > 0 &&
      this.screen.assets.some(asset => {
        const type = asset?.assetType?.replace('.', '').toLowerCase();
        return asset?.url?.trim() && allowedType.includes(type);
      });
  }
  // Layout helpers for media rendering
  get hasMedia(): boolean {
    return !!(this.screenContent && this.screenContent.media && (this.screenContent.media.type && this.screenContent.media.type?.toLowerCase() != 'none') && (this.screenContent.media.url?.trim()?.length > 0 || this.hasValidAsset));
  }

  onSeekStart() {
  const audio = this.audioPlayer.nativeElement;

  this.isPlaying = true;
  this.wasPlayingBeforeSeek = !audio.paused;

  audio.pause(); 
}

  onSeekEnd(event: any) {
    const audio = this.audioPlayer.nativeElement;

    const seekTo = event.detail.value;
    audio.currentTime = seekTo; 

    if (this.wasPlayingBeforeSeek) {
      audio.play(); 
    }

    this.isPlaying = false;
  }
  get isImageFullBleed(): boolean {
    // return this.hasMedia && this.screenContent.media.type === 'image'
    return this.hasMedia && (this.screenContent.media.type === 'image'|| this.screenContent.media.type) && (this.screenContent.fullBleed || this.screenContent.full_bleed || this.screenContent.blend_mode) && (this.screenImageUrl || this.screenAssetsImageUrl) && !this.isVideo && !this.isAudio && !this.isDocument;
  }

  get isImageHalfBleed(): boolean {
    // return this.hasMedia && this.screenContent.media.type === 'image'
    return this.hasMedia && (this.screenContent.media.type === 'image'|| this.screenContent.media.type) && (!this.screenContent.fullBleed && !this.screenContent.full_bleed && !this.screenContent.blend_mode) && (this.screenImageUrl || this.screenAssetsImageUrl) && !this.isVideo && !this.isAudio && !this.isDocument;
  }

  get isVideo(): boolean {
    const url = this.screenContent?.media?.url;
    return this.hasMedia && url?.trim()?.length > 0 && (this.screenContent.media.type === 'video' || this.isVideoUrl(url));
  }

  isVideoFile(url?: string): boolean {
    return ['mp4', 'webm', 'ogv', 'mov', 'm4v', 'm3u8'].includes(this.getExtension(url));
  }

  // Returns an embeddable player URL for YouTube / Vimeo links, or null for anything else.
  getVideoEmbedUrl(url?: string): string | null {
    if (!url) return null;
    const youtubeId = this.getYoutubeId(url);
    if (youtubeId) {
      return `https://www.youtube.com/embed/${youtubeId}?rel=0&playsinline=1`;
    }
    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }
    return null;
  }

  getYoutubeId(url?: string): string | null {
    return url?.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?(?:.*&)?v=|v\/|shorts\/|live\/))([a-zA-Z0-9_-]{11})/)?.[1] ?? null;
  }

  openYoutubePreview() {
    this.isContentViewed = true;
    this.playRemoteVideo(this.youtubePreview.watchUrl);
  }

  isVideoUrl(url?: string): boolean {
    return this.isVideoFile(url) || !!this.getVideoEmbedUrl(url);
  }

  get isAudio(): boolean {
    return this.hasMedia && this.screenContent.media.type === 'audio' && this.screenContent.media.url?.trim()?.length > 0;
  }

  get backgroundImage() {
  const url = this.screenAssetsImageUrl ?? this.screenImageUrl;
  return ((this.isImageFullBleed || this.isImageHalfBleed || this.isDocument || this.isVideo || this.isAudio) && url) ? `url(${url})` : null;
}

  getExtension(url?: string): string {
    if (!url && url?.trim()?.length == 0) return '';

    try {
      const pathname = new URL(url).pathname;
      return pathname.split('.').pop()?.toLowerCase() ?? '';
    } catch {
      return '';
    }
  }

  isPdf(url?: string): boolean {
    return this.getExtension(url) === 'pdf';
  }
  // downloadInWeb(url: string, fileName?: string) {
  //   const anchor = document.createElement('a');
  //   anchor.href = url;
  //   anchor.download = fileName || '';
  //   anchor.target = '_blank';
  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // }
  // downloadInWebWiitthCors(url) {
  //     const name = url.substr(url.lastIndexOf("/") + 1);
  //   const fileName = name.split("?")[0];
  //   fetch(url)
  //     .then(res => res.blob())
  //     .then(blob => {
  //       const blobUrl = window.URL.createObjectURL(blob);

  //       const a = document.createElement('a');
  //       a.href = blobUrl;
  //       a.download = fileName;
  //       a.style.display = 'none';

  //       document.body.appendChild(a);
  //       a.click();

  //       document.body.removeChild(a);
  //       window.URL.revokeObjectURL(blobUrl);
  //     })
  //     .catch(err => console.error('Download failed', err));
  // }
  downloadInWeb(url: string) {
    if (!url) return;
    this.isContentViewed = true;
    const fileName = url.split('/').pop()?.split('?')[0];
    const a = document.createElement('a');
    a.href = url;
    a.target = '_self';     // important for mobile Safari
    a.rel = 'noopener';
    a.download = '';        // filename from server headers
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    this.toasterService.success(
      `${fileName} ${this.i18n.t('downloaded successfully')}`
    );

  }

  async downloadDocument(url) {
    if (url && this.platform.is('mobileweb')) {
      this.downloadInWeb(url)
    }
    else if (url) {

      this.loadingCtrl.create({
        message: this.i18n.t('Loading...')
      }).then(loader => {
        loader.present();
        const transfer = this.transfer.create();
        let path = null;
        const name = url.substr(url.lastIndexOf("/") + 1);
        const fileName = name.split("?")[0];
        if (this.platform.is("ios")) {
          path = this.file.documentsDirectory;
        } else {
          path = this.file.dataDirectory;
        }
        transfer.download(url, this.file.dataDirectory + fileName).then((entry) => {
          this.file.resolveLocalFilesystemUrl(entry.toURL()).then((fileEntry: any) => {
            let filePath = fileEntry.nativeURL;
            console.log('new file path: ', filePath);
            loader.dismiss();
            if (filePath) {
              this.socialSharing.share("", "", filePath, "")
                .then((entries) => {
                  console.log('success ' + JSON.stringify(entries));
                })
                .catch((error) => {
                  console.log('error ' + JSON.stringify(error));
                });
            }
          }).catch((error) => {
            console.log('download failed: ', error);
          });
        })
      });
    }

  }

  isDownloadOnly(url?: string): boolean {
    return ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv', 'txt']
      .includes(this.getExtension(url));
  }
  get isDocument(): boolean {
    if (!this.hasMedia || this.isVideo) return false;
    const t = (this.screenContent.media.type || '').toString().toLowerCase();
    return ['document', 'pdf', 'doc', 'docx', 'attachment', 'file','url','link', 'ppt', 'pptx', 'txt', 'csv', 'xlsx', 'xls'].includes(t);
  }

  playVideo(event?: Event) {
    event?.stopPropagation();
    const video = this.videoPlayer.nativeElement as any;
    this.isPaused = true;
    this.isContentViewed = true;
    // iOS (Safari / WKWebView)
    if (video.webkitEnterFullscreen) {
      video.play();
      video.webkitEnterFullscreen();
      return;
    }
    // Standard Fullscreen API
    if (video.requestFullscreen) {
      video.requestFullscreen().then(() => video.play()).catch(() => video.play());
      return;
    }
    video.play();
    console.log(" this.videoPlayer", this.videoPlayer, this.videoPlayer.nativeElement)
  }

  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  onClickHandler() {
    this.onClick.emit()
    return false
  }
  toggleOpen(){
    
    if(!this.fabComponent?.activated){
      this.showBackdrop = true;

      if(this.isMobile){
        const intervalId = setInterval(() => {
          this.addTextAnimation = false;
        }, 100);
  
        setTimeout(() => {
          clearInterval(intervalId);
        }, 5000);
      }


      this.appState.set('isFabClicked',true)
      this.showFilledBookmark = true
    }
    }
    contentClick(event: Event) {
          if (this.appState.get('isFabClicked')==false && this.showBackdrop) {
            this.showBackdrop = false;
            this.showFilledBookmark = false;
            if(this.fabComponent?.activated){
              this.fabComponent.close();
            }
          }   
          if(this.appState.get('isFabClicked')) {
            this.appState.set('isFabClicked',false)
          }
    }

  onBackHandler(event) {
    event.stopPropagation()
    this.onBack.emit()
    return false
  }

  onCloseHandler(event) {
    event.stopPropagation()
    this.onClose.emit()
    return false
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {
    this.contentClick(e);
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        console.log('cordova click')
        e.stopPropagation()
        e.preventDefault()
        if (this.sessionService.confirmYoutubeUrl(e.target.href)) {
          this.playRemoteVideo(e.target.href)
          mixpanel.track('Library-clicked on link', {'link': this.playRemoteVideo(e.target.href)})
        }else{
          this.cordovaService.openLinkInBrowser(e.target.href)
          mixpanel.track('Library-clicked on link', {'link': this.cordovaService.openLinkInBrowser(e.target.href)})
        }
      } else {
        window.open(e.target.href, '_blank')    
        console.log('clicked on a link :', );
        mixpanel.track('Library-clicked on link', {'link': e.target.href})
      }
    }
  }
  playRemoteVideo(url: string) {
    if (this.sessionService.confirmYoutubeUrl(url)) {
      console.log('Youtube video :');
      if (this.platform.is('ios')) {
        try {
          // Try to run this code 
          console.log("in try block");
          this.cordovaService.openBrowserLinkVideo(url);
          // this.youtubePlayer.openVideo(this.sessionService.getYouTubeVideoIdFromUrl(url));
        }
        catch(err) {
          // if any error, Code throws the error
          console.log("catch_block", err);
        }
      }  else if(this.platform.is('android')){
        this.cordovaService.openBrowserLinkVideo(url);
      } else {
        this.cordovaService.openBrowserLinkVideo(url);
      }
    }
  }

  nextScreen() {
    let data = {
      stepId: this.screen?.stepId,
      screenId: this.screen?.screenId,
      screenContentId: this.screen?.screenContentId,
    }
    if (this.formatTime(this.duration - this.currentTime) == '0:00' || this.isContentViewed) {
      data['is_content_viewed'] = true;
    }
    if ((!this.screen?.screen?.isCompleted && !this.isAudio && !this.isVideo && !this.isDocument) || (!this.screen?.screen?.isCompleted && (this.isAudio || this.isVideo || !this.isDocument) && this.isContentViewed)) {
      this.kyperuserDataApiService.updateContentScreenCompletion(data).subscribe((res) => {
        mixpanel.track('Content Screen Completed', {
          'stepId': this.screen?.stepId,
          'screenId': this.screen?.screenId,
          'screenContentId': this.screen?.screenContentId,
          'viewedAudioTime': this.formatTime(this.duration - this.currentTime),
          res: res
        });
        this.screen.screen.isCompleted = true;
        let path = this.appState.get('currentPath')
        let stepScreens = path.kyperChapters?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents
        if (stepScreens) { stepScreens.isCompleted = true; }
        let dailyStepsData = this.appState.get('DailyStepsData');
        let dailyStepScreens = dailyStepsData?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents;
        if (dailyStepScreens) { dailyStepScreens.isCompleted = true; }
        this.appState.set('DailyStepsData', dailyStepsData);
        this.appState.set('currentPath', path)
        this.appState.set('allowNext', true)
        this.checkLibraryStatus(this.poll, this.survey, this.document, this.question, this.habit)
        this.cdRef.detectChanges()
      })
    } else {
      this.appState.set('allowNext', true)
      this.checkLibraryStatus(this.poll, this.survey, this.document, this.question, this.habit)
      this.cdRef.detectChanges()
    }
  }

  checkLibraryStatus(poll,contentSurvey,document,question,habit){
    let savedContentIds, habitId, surveyId, pollId, questionId, flag =false;
    let savedLibraryPosts = this.appState.get('savedPosts')
    savedLibraryPosts?.forEach(element => {
       habitId = this.currentPath.filterStepsByContentType('habits',element?.data)?.[0]?.screen?.id ?? null;
      surveyId = this.currentPath.filterStepsByContentType('assessment',element?.data)?.[0]?.screen?.id ?? null;
      pollId = this.currentPath.filterStepsByContentType('poll',element?.data)?.[0]?.screen?.id ?? null;
      questionId = this.currentPath.filterStepsByContentType('social',element?.data)?.[0]?.screen?.id ?? null;
      let screenContents = this.currentPath.filterStepsByContentType('content',element?.data)
      savedContentIds = screenContents?.length>0? screenContents?.map(content=>content.screenContentId) : null;
            if (habitId && habitId === this.habit?.screenContentId || savedContentIds &&savedContentIds.includes(this.screen?.screenContentId) ||
        pollId && pollId === this.poll?.[0]?.screenContentId || surveyId && surveyId === this.survey?.screenContentId || questionId && questionId === this.question?.screenContentId) {
          if (this.currentPath.filterStepsByContentType('habits',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('assessment',element?.data)?.length > 0 ||
            this.currentPath.filterStepsByContentType('poll', element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('social', element?.data)?.length > 0
          || this.currentPath.filterStepsByContentType('content',element?.data)?.length > 0) {
              this.isAlreadyPresent = true
              flag =true;
          }
          else if(!flag) {
            this.isAlreadyPresent =undefined
          }
      }
      else if(!flag) {
        this.isAlreadyPresent =undefined
      }
    });

    let recentSavedPost = this.appState.get('recentSavedStep')
    let recentSavedDocumentId = recentSavedPost?.documents?.[0]?.id
    let recentSavedHabitId = recentSavedPost?.habits?.[0]?.id
    let recentSavedPollId = recentSavedPost?.polls?.[0]?.id
    let recentSavedQuestionId = recentSavedPost?.questions?.[0]?.id
    let recentSavedSurveyId = recentSavedPost?.contentSurveys?.[0]?.id
    if (recentSavedDocumentId || recentSavedHabitId || recentSavedPollId || recentSavedSurveyId || recentSavedQuestionId) {
      if (recentSavedPost?.habits?.length > 0 || recentSavedPost?.contentSurveys?.length > 0 ||
        recentSavedPost?.polls?.length > 0 || recentSavedPost?.questions?.length > 0) {
          this.isAlreadyPresent = true
      }
    }

    if (this.appState.get('isNewStep')) {
      this.isAlreadyPresent = undefined
    }

    this.cdRef.detectChanges()
  }

  getCurrentScreenData() {
    let savedContentId
    let habitId, surveyId, pollId, questionId;
    let isAlreadyCreated, presentPost;
    console.log('this.savedLibraryPosts :', this.savedLibraryPosts);
    this.savedLibraryPosts?.forEach(element => {
      // savedDocumentId = element.documents[0]?.id
      habitId = this.currentPath.filterStepsByContentType('habits',element?.data)?.[0]?.screen?.id ?? null;
      surveyId = this.currentPath.filterStepsByContentType('assessment',element?.data)?.[0]?.screen?.id ?? null;
      pollId = this.currentPath.filterStepsByContentType('poll',element?.data)?.[0]?.screen?.id ?? null;
      questionId = this.currentPath.filterStepsByContentType('social',element?.data)?.[0]?.screen?.id ?? null;
      savedContentId = this.currentPath.filterStepsByContentType('content',element?.data)?.[0]?.screen?.id ?? null;
      if (habitId && habitId === this.habit?.screenContentId || savedContentId &&savedContentId ==this.screen?.screenContentId ||
        pollId && pollId === this.poll?.[0]?.screenContentId || surveyId && surveyId === this.survey?.screenContentId || questionId && questionId === this.question?.screenContentId) {
          if (this.currentPath.filterStepsByContentType('habits',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('assessment',element?.data)?.length > 0 ||
            this.currentPath.filterStepsByContentType('poll',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('social',element?.data)?.length > 0
          || this.currentPath.filterStepsByContentType('content',element?.data)?.length > 0) {
              console.log('step is there');
              this.isAlreadyPresent = true
              presentPost = element
          }
      }
    });


    this.recentSavedPost = this.appState.get('recentSavedStep')
    console.log('recentSavedPost :', this.recentSavedPost);
    let recentSavedDocumentId = this.recentSavedPost?.documents?.[0]?.id
    let recentSavedHabitId = this.recentSavedPost?.habits?.[0]?.id
    let recentSavedPollId = this.recentSavedPost?.polls?.[0]?.id
    let recentSavedQuestionId = this.recentSavedPost?.questions?.[0]?.id
    let recentSavedSurveyId = this.recentSavedPost?.contentSurveys?.[0]?.id

    this.appState.set('isFabClicked', true);
      if (this.fabComponent?.activated) {
        this.fabComponent.close();
      }
    this.showFilledBookmark = true;

    if (this.isAlreadyPresent) {
      if(this.isMobile) {
        const dialogRef = this.dialog.open(AlertDeletePostComponent)
        dialogRef.afterClosed().subscribe((result) => {
          if(result === 'confirm'){
            this.deletePost(presentPost)
          }
        })  
      }
      else {
        this.deletePostAlert(presentPost)
      }
    } else if(recentSavedDocumentId||recentSavedHabitId||recentSavedPollId||recentSavedSurveyId||recentSavedQuestionId){
      if (recentSavedHabitId === this.habit?.id || recentSavedPollId === this.poll?.id || recentSavedSurveyId === this.survey?.id || recentSavedQuestionId === this.question?.id) {
        if(this.isMobile) {
          const dialogRef = this.dialog.open(AlertDeletePostComponent)
          dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirm') {
              this.deletePost(this.recentSavedPost)
            }
          })
        }
        else {
          this.deletePostAlert(this.recentSavedPost)
        }
      }else{
        if(!this.isMobile) {
          this.savePostAlert()
        }
        else {
          this.savePost()
        }
      }
    } else {
      if(!this.isMobile) {
        this.savePostAlert()
      }
      else {
        this.savePost()
      }
    }
    if(this.isMobile){
      this.addTextAnimation = false;
    }
  }
  async deletePostAlert(doc){
    const alert = await this.alertController.create({
      
      subHeader: this.i18n.t("Delete Post"),
      message: this.i18n.t("Do you want to delete this post?"),
      cssClass:this.homeUIService.isDark()?'dark-theme alertBackdrop ':' light-theme alertBackdrop',
      buttons: [
        {
          text: this.i18n.t("Cancel"),
          handler:()=>{
           
          },
          role: 'cancel',
        },
        {
          text: this.i18n.t("Confirm"),
          cssClass: 'custom-alert',
          handler: async () => {
            this.deletePost(doc)
          },
        },
      ]  
     });
  
    await alert.present();
  }

  @ViewChild('scrollContainer')
  set scrollContainer(el: ElementRef) {
    if (el) {
      setTimeout(() => {
        this.initResizeObserver(el.nativeElement);
      }, 100);
    } else {
      this.resizeObserver?.disconnect();
    }
  }

initResizeObserver(el: HTMLElement) {
  this.resizeObserver?.disconnect();
  this.hasScrollbar = el.scrollHeight > el.clientHeight;
  this.showScrollToBottom = el.scrollHeight - el.scrollTop - el.clientHeight > this.BOTTOM_THRESHOLD;
  this.cdRef.detectChanges();

  this.resizeObserver = new ResizeObserver(() => {
    this.hasScrollbar = el.scrollHeight > el.clientHeight;
    this.showScrollToBottom = el.scrollHeight - el.scrollTop - el.clientHeight > this.BOTTOM_THRESHOLD;
    this.cdRef.detectChanges();
  });
  // el is a fixed-size box (absolutely positioned, top/bottom pinned), so its own box size never
  // changes when inner content grows/settles asynchronously. Observe its children too so
  // late-rendering content still triggers a recheck of el's scrollHeight vs clientHeight.
  this.resizeObserver.observe(el);
  Array.from(el.children).forEach(child => this.resizeObserver.observe(child));
}

bottomonScroll(elRef: ElementRef | HTMLElement): void {
  const el = (elRef as ElementRef)?.nativeElement ?? elRef as HTMLElement;
  const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
  this.showScrollToBottom = distanceFromBottom > this.BOTTOM_THRESHOLD;
  this.cdRef.detectChanges();
}

scrollToBottom(elRef: ElementRef | HTMLElement): void {
  const el = (elRef as ElementRef)?.nativeElement ?? elRef as HTMLElement;
  this.showScrollToBottom = false;

  el.scrollTo({ top: el.scrollHeight - el.clientHeight, behavior: 'smooth' });

  let scrollEndFired = false;
  const checkScrollEnd = () => {
    scrollEndFired = true;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    this.showScrollToBottom = distanceFromBottom > this.BOTTOM_THRESHOLD;
    this.cdRef.detectChanges();
  };

  el.addEventListener('scrollend', checkScrollEnd, { once: true });
  setTimeout(() => { if (!scrollEndFired) checkScrollEnd(); }, 500);
}


  ngOnDestroy() {
    this.fontSizeSubscription?.unsubscribe();
    this.fontSizeSaveSubscription?.unsubscribe();
    if(this.appState.get('isLevelClosedBeforeCommit')) {
      return;
    }
    this.appState.set('screenStatus', null);
    this.appState.set('hidePrevScreen', false)
    if(!this.flag) {
      this.sessionService.removeAppStateOnContentClose()
      let prevPathData = this.appState.get('prevPathData')
      if (prevPathData) {
        this.sessionService.changePathToLibrary(prevPathData)
        this.appState.set('prevPathData',undefined)
      }
    }
    this.resizeObserver?.disconnect();
  }
  fetchStepSatus(){
    let dailySteps = this.appState.get("DailyStepsData");
    dailySteps.forEach((step)=>{
      if(step?.stepStatus =='Review' && step?.step<dailySteps?.length )
      {
          this.appState.set('currentScheduleDay', step?.step+1);
          this.appState.set('scheduleDayForCurrentStep',  step?.step+1);
      }
    })
  }

  updateStreaksData() {
    this.streaksInfo = this.appState.get('dailyStreaksInfo');
    if (!this.streaksInfo?.todays_streak) {
      this.homeUIService.fetchDailyStreaksInfo(this.currentDay).subscribe((data) => {
        this.appState.set('isStreaksInfoUpdated', true);
        this.appState.set('updatedStreaksInfo', data?.data);
        this.sessionService.generateStreakWeekDays(data?.data);
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning(this.i18n.t(this.i18n.t("Error, while storing streaks info!")));
      });
    }
  }
  close() {
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    let dailyStepsArray = this.appState.get("DailyStepsData");
    this.allowScreenCount = this.appState.get('allowScreenCount');
    // if(this.appState.get('isLevelCommited')!==false) {
    this.flag=true;
    if (this.allowScreenCount && this.currentDay == scheduledStep && dailyStepsArray[scheduledStep - 1]?.stepStatus != 'Review') {
      if (this.currentIndex + 1 == this.screensIds?.length) {
        this.appState.set('isStreaksScreenNotVisited', true);
        this.updateStreaksData();
      }
      // this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
      // this.utilService.setScreenCount()
    }
    if (this.appState.get('routine_schedule_day')) {
      this.appState.set('routine_schedule_day', null)
    }
    this.sessionService.removeAppStateOnContentClose()
    let prevPathData = this.appState.get('prevPathData')
    if (prevPathData) {
      this.sessionService.changePathToLibrary(prevPathData)
      this.appState.set('prevPathData',undefined)
    }
    if (this.backTo) {
      this.router.navigate([this.backTo])
      this.fetchStepSatus();
      this.appState.set('isHomeScreen', true)
    } else {
      if(this.isMobile) {
       this.router.navigate(['/main'])
      }
      else {
        this.modalController.dismiss();
      }
      this.fetchStepSatus();
      this.appState.set('isHomeScreen', true)
    }
    if (this.appState.get('isRouteToLibrary')) {
      if(this.isMobile) {
        this.router.navigate(['/main'])
       }
       else {
         this.modalController.dismiss();
       }      this.fetchStepSatus();
      // this.router.navigate(['/main'])
    //  this.router.navigate(['/main/library'])
      //this.navCtrl.navigateBack('/detail-reflection');
      this.appState.set('isRouteToLibrary', undefined)
    }
    if(this.appState.get('isYourPathPrevious')) {
       this.appState.set('isYourPathPrevious',false);
       //this.appState.set('isHamburgerOpen', true);
      this.fetchStepSatus()
      let isChaptersEnabled = this.currentPath?.chapters?.length>0 && this.currentPath['enabledAttributes']?.chapters ==true
       setTimeout(()=>{
        this.homeUIService.openNextComponent(isChaptersEnabled? YourPathNewComponent:YourPathComponent);
       },600);
    }
  // }
  // else {
  //   this.toasterService.warning(this.i18n.t('Please commit habit level before closing step'));
  // }
   
  }
  async savePostAlert(){
    const alert = await this.alertController.create({
      subHeader: this.i18n.t('Save to Library'),
      cssClass:this.homeUIService.isDark()?'dark-theme alertBackdrop':' light-theme alertBackdrop',
       inputs: [
        
         {
           name:'textarea',
           type:'textarea',
           cssClass:'web-textarea',
           placeholder: this.i18n.t('My notes on this step'),
         },
        
       ],
       buttons: [
        {
          text: this.i18n.t('Cancel'),
          handler:()=>{
            this.showFilledBookmark = false;
          },
          role:'Cancel'
        },
         {
           text: this.i18n.t("Save"),
           cssClass: 'custom-alert', 
             handler: (alertData: AlertInput) => {
              console.log("alertData in saved step",alertData['textarea'])
              localStorage.setItem('journalNote',alertData['textarea']);
              if (alertData['textarea']) {
                let text = localStorage.getItem('journalNote')
                // const requestData = {
                //   'text': [text],
                //   'pathId': this.currentPath.id,
                //   'contentSurveyId': this.survey?.id,
                //   'habitId': this.habit?.id,
                //   'pollId': this.poll?.id,
                //   'documentId': this.document?.id,
                //   'questionId': this.question?.id,
                //   'inoutScreenId': this.screenContent?.id,
                //   'screenId': this.savedScreenId,
                //   'reflectionId': this.reflection?.id
                // }
                let input = {
                  screen_content_id: this.screenContent?.id,
                  step_id: this.screen?.stepId,
                  note: [text],
                  saved_type: 'step'
                }
        
                //this.spinnerService.on()
                this.libraryService.save(input).subscribe((response) => {
                  this.savedLibraryPosts = this.sessionService.getLibraryPosts();
                this.isAlreadyPresent =true;
                if(this.appState.get('FirstTimeTabCheck')){
                  this.appState.set('tabLabel', 'saved')
                }
                  console.log('response :', response);
                  this.postToJournal = response?.data;
                  this.appState.set("recentSavedStep",this.postToJournal)
                  this.toasterService.success(this.i18n.t('Step saved.'))
                  this.cdRef.detectChanges()
                },
                  (error) => {
                    this.spinnerService.off()
                    console.log('error :', error);
                  })
              }
             else {
                this.toasterService.warning(this.i18n.t("Please enter valid notes"))
              } 
        }
        
         },
        ],
     });
     await alert.present();
  }
  savePost(){
    const dialogRef = this.dialog.open(AlertAddNotesComponent)
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'confirm') {
          let text = localStorage.getItem('journalNote')
          // const requestData = {
          //   'text': [text],
          //   'pathId': this.currentPath.id,
          //   'contentSurveyId': this.survey?.id,
          //   'habitId': this.habit?.id,
          //   'pollId': this.poll?.id,
          //   'documentId': this.document?.id,
          //   'questionId': this.question?.id,
          //   'inoutScreenId': this.screenContent?.id,
          //   'screenId': this.savedScreenId,
          //   'reflectionId': this.reflection?.id
          // }

          // this.spinnerService.on()
            let input = {
                  step_id: this.screen?.stepId,
                  note: [text],
                  saved_type: 'step'
                }
          this.libraryService.save(input).subscribe((response) => {
            this.savedLibraryPosts = this.sessionService.getLibraryPosts();
          this.isAlreadyPresent =true;
          if(this.appState.get('FirstTimeTabCheck')){
            this.appState.set('tabLabel', 'saved')
          }
            console.log('response :', response);
            this.postToJournal = response?.data;
            this.appState.set("recentSavedStep",this.postToJournal)
            this.toasterService.success(this.i18n.t('Step saved.'))
            this.cdRef.detectChanges()
          },
            (error) => {
              this.spinnerService.off()
              console.log('error :', error);
            })
        }
        this.showFilledBookmark = false;
      })
  }

  playAudio(link)
  {
     this.audioPlayer.nativeElement.play();
  }
  async isMediaContentViewed(type) {
    this.isContentViewed = true;
    const modal = await this.modalController.create({
      component: MediaTypesScreenComponent,
      componentProps:{type:type,screenData:this.screenContent},
      cssClass:this.isMobile?'custom-modal': 'desktop-library-custom',
      enterAnimation: this.animationService.slideInLeftEnterAnimation,
      leaveAnimation: this.animationService.SlideOutRightLeaveAnimation
    });
    await modal.present()   
  }

  openDocument(url) {
    // if(url.toLowerCase().endsWith('.docx')|| url.toLowerCase().endsWith('.doc') || url.toLowerCase().endsWith('.pptx') || url.toLowerCase().endsWith('.ppt')) {
    //   url = 'https://docs.google.com/viewer?url=' + url;
    // }
    this.isContentViewed = true;
     if (this.cordovaService.onCordova) {
        this.cordovaService.openLinkInBrowser(url);
      } else {
        window.open(url, "_blank");
      }
  }
  togglePlay() {
    const audio = this.audioPlayer?.nativeElement;
    this.isContentViewed = true;
    if (audio.paused) {
      audio.play();
      this.isPlaying = true;
    } else {
      audio.pause();
      this.isPlaying = false;
    }
  }

  onLoadedMetadata() {
    const audio = this.audioPlayer.nativeElement;
    this.duration = audio.duration || 0;

  }

  onTimeUpdate() {
    const audio = this.audioPlayer.nativeElement;
    this.currentTime = audio.currentTime;
    // this.isPlaying = !audio.paused;
    // this.currentTime = this.audioPlayer?.nativeElement?.currentTime;
  }

  seekAudio(event: any) {
    const audio = this.audioPlayer?.nativeElement;
    // if(audio) {
      audio['currentTime'] = event.detail.value;
    // }
  }

  seekBy(seconds: number) {
    const audio = this.audioPlayer.nativeElement;
    audio.currentTime = Math.min(
      Math.max(audio.currentTime + seconds, 0),
      this.duration
    );
  }

  onEnded() {
    this.isPlaying = false;
    this.currentTime = 0;
  }

  formatTime(time: number): string {
    if (!time) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  deletePost(post) {
    console.log('deleted', post);
    const requestData = {
      id: post?.id
    }
    console.log('requestData :', requestData);
    this.spinnerService.on();
    this.libraryService.deletePost(post?.id,'step').subscribe(
      (response) => {
        this.savedLibraryPosts = this.sessionService.getLibraryPosts()
        this.isAlreadyPresent = undefined
        this.appState.set('recentSavedStep', undefined)
        this.cdRef.detectChanges()
        console.log('response :', response);
        this.toasterService.success(this.i18n.t('Post Deleted!'))        
      },
      (error) => {
        this.spinnerService.off();
        console.log('Error for feedback ', error)
      }
    )
    this.showFilledBookmark = false;
  }

  increaseFontSize() {
    if (this.headingFontSize < 30) {
      const newHeading = Math.round((this.headingFontSize + 2) * 100) / 100;
      const newBody = Math.round((this.bodyFontSize + 2) * 100) / 100;
      this.homeUIService.updateFontSize(newHeading, newBody);
      this.fontSizeSaveSubject.next({ headingFontSize: newHeading, bodyFontSize: newBody });
    }
  }

  decreaseFontSize() {
    if (this.headingFontSize > 20 && this.bodyFontSize > 12) {
      const newHeading = Math.round((this.headingFontSize - 2) * 100) / 100;
      const newBody = Math.round((this.bodyFontSize - 2) * 100) / 100;
      this.homeUIService.updateFontSize(newHeading, newBody);
      this.fontSizeSaveSubject.next({ headingFontSize: newHeading, bodyFontSize: newBody });
    }
  }

  private savePathRegistrationFontSize(headingFontSize: number, bodyFontSize: number) {
    this.pathRegistration = this.pathRegistration || {};
    this.pathRegistration.pathData = this.pathRegistration.pathData || {};
    this.pathRegistration.pathData.headingFontSize = parseFloat(String(headingFontSize));
    this.pathRegistration.pathData.bodyFontSize = parseFloat(String(bodyFontSize));
    this.appState.set('pathRegistration', this.pathRegistration);

    const { __typename, ...pathData } = this.pathRegistration.pathData as any;
    const pathRegistration = new PathRegistration({
      userId: this.currentUser?.id,
      pathId: this.currentPath?.id,
      pathData,
    });
    this.userService.savePathRegistration(pathRegistration).subscribe(
      (response: any) => {
        this.pathRegistration = response.data.updatePathRegistration;
        this.appState.set('pathRegistration', this.pathRegistration);
      },
      (error) => {
        console.log('Error saving font size preference', error);
      }
    );
  }

  changeSubTextFont() {
  if (this.stepTitle) {
    const mainElement = this.stepTitle.nativeElement;

    // Check for dark or light theme
    const isDarkTheme = this.homeUIService?.isDark();
    const targetColor = isDarkTheme ? 'rgb(255, 255, 255)' : 'rgb(0, 0, 0)';
    const currentColorMatcCheck = isDarkTheme ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)';

    // Apply styles to all inner tags based on conditions
    this.applyStylesToAllInnerTags(mainElement, 'color', targetColor, currentColorMatcCheck);
    //this.patchIframesForFullscreen();
  }
}

applyStylesToAllInnerTags(element: HTMLElement, styleProperty: string, styleValue: string, currentColorMatcCheck: string) {
  const isDarkTheme = this.homeUIService?.isDark();
  const headingColor = isDarkTheme ? '#E9EDF5' : '#101828';
  const paraColor = isDarkTheme ? '#E9EDF5' : '#364153';
  const iframeBgcolor = isDarkTheme ? '#00000080' : '#FFFFFF80';

  const childElements = Array.from(element.children);
  
  // console.log(childElements, 'childElement');
  childElements.forEach((childElement: Element) => {
    const childColor = window.getComputedStyle(childElement).color;
    const childBgColor = window.getComputedStyle(childElement).backgroundColor;
    const tagName = childElement.tagName.toLowerCase();
    // Apply the style only if the current color matches the specified condition
    if (childColor === currentColorMatcCheck && (childBgColor==currentColorMatcCheck  || childBgColor=='rgba(0, 0, 0, 0)')) {
      this.render.setStyle(childElement, styleProperty, styleValue);
    }
    if (childBgColor === childColor) {
      styleValue = this.homeUIService.getContrastColor(this.homeUIService.rgbToHex(childColor));
      this.render.setStyle(childElement, styleProperty, styleValue);
    }


    if ( childElement.tagName.toLowerCase() === 'img' && childElement.parentElement?.tagName?.toLowerCase() === 'p' ){
      const parentEl = childElement.parentElement;
      this.render.setStyle(parentEl, 'text-align', 'center');
    }
    else if(
      childElement.tagName.toLowerCase() === 'img' && childElement.parentElement?.tagName?.toLowerCase() === 'p'){
      const parentEl = childElement.parentElement;
    }
     if (tagName === 'img') {
      // 🖼️ Apply image-specific styles
      this.render.setStyle(childElement, 'width', '242px');
      this.render.setStyle(childElement, 'margin', 'auto');
      this.render.setStyle(childElement, 'border-radius', '4px');
      this.render.setStyle(childElement, 'height', '278px');
      this.render.setStyle(childElement, 'display', 'block');
      this.render.setStyle(childElement, 'object-fit', 'contain');
    } else if((tagName === 'iframe')){
      this.render.setStyle(childElement, 'color', paraColor);
      this.render.setStyle(childElement, 'font-size', '14.44px');
      this.render.setStyle(childElement, 'line-height', '25.59px');
      this.render.setStyle(childElement, 'font-family', 'Roboto');
      this.render.setStyle(childElement, 'border', '1px solid rgba(200, 200, 200, 0.3)');
      this.render.setStyle(childElement, 'border-radius', '4px');
      this.render.setStyle(childElement, 'padding', '26px 44px');
      this.render.setStyle(childElement, 'min-height', '250px');
      this.render.setStyle(childElement, 'background', iframeBgcolor);
      this.render.setStyle(childElement, 'backdrop-filter', 'blur(7px)');
      this.render.setStyle(childElement, 'box-shadow', 'rgba(0, 0, 0, 0.25) 0px 4px 4px 0px');
      
    }
    // else if(tagName === 'br'){
    //   this.render.setStyle(childElement, 'display', 'none');
    // }
    else if(tagName === 'p'){
      this.render.setStyle(childElement, 'font-size', `${this.bodyFontSize}px`);
      this.render.setStyle(childElement, 'font-family', 'Roboto');
      this.render.setStyle(childElement, 'line-height', '1.77');
      this.render.setStyle(childElement, 'color', paraColor);
      this.render.setStyle(childElement, 'margin-bottom', '0');

      // Check if the p element has no text content
      // const hasText = (childElement.textContent || '').trim().length > 0;
      // const hasNonEmptyChild = Array.from(childElement.children).some(
      //   (el: Element) => (el.textContent || '').trim().length > 0
      // );
      // const hasImage = childElement.querySelector('img') !== null;
      // if (!hasText && !hasNonEmptyChild && !hasImage) {
      //   this.render.setStyle(childElement, 'display', 'none');
      // }

    }else if(tagName === 'ol'){
      const liElements = childElement.querySelectorAll('li[data-list]');
      liElements.forEach((li: Element) => {
        const dataList = li.getAttribute('data-list');
        if(dataList === 'bullet'){
          this.render.setStyle(li, 'list-style-type', 'disc');
          this.render.setStyle(li, 'color', paraColor);
        } else if(dataList === 'ordered'){
          this.render.setStyle(li, 'list-style-type', 'decimal');
          this.render.setStyle(li, 'color', paraColor);
        }
      });
    }
    // Recursively apply styles to child elements
    this.applyStylesToAllInnerTags(childElement as HTMLElement, styleProperty, styleValue, currentColorMatcCheck);
  });
}

}
